export default __webpack_public_path__ + "static/media/Camilo-Espinosa-Resume.a9d8fe41.pdf";